import { createFileRoute } from '@tanstack/react-router';
import {
  BrainCircuit,
  Database,
  Fingerprint,
  HardDrive,
  Link2,
  LockKeyhole,
  ScrollText,
  ShieldCheck,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  MarketingCta,
  MarketingPageHeader,
  MarketingShell,
} from '../features/marketing/marketing-shell';
import { useMarketingMetadata } from '../features/marketing/marketing-metadata';

export const Route = createFileRoute('/security')({ component: SecurityPage });
const icons = [Fingerprint, ShieldCheck, LockKeyhole, Link2, HardDrive, ScrollText, BrainCircuit];

function SecurityPage() {
  const { t } = useTranslation();
  useMarketingMetadata(t('marketing.security.metaTitle'), t('marketing.security.description'));
  return (
    <MarketingShell>
      <MarketingPageHeader
        eyebrow={t('marketing.nav.security')}
        title={t('marketing.security.title')}
        description={t('marketing.security.description')}
      />
      <section className="security-principles">
        {icons.map((Icon, index) => (
          <article key={index}>
            <span>
              <Icon aria-hidden="true" />
            </span>
            <div>
              <h2>{t(`marketing.security.item${index + 1}Title`)}</h2>
              <p>{t(`marketing.security.item${index + 1}Description`)}</p>
            </div>
          </article>
        ))}
        <aside>
          <Database aria-hidden="true" />
          <p>{t('marketing.security.noCertificationClaim')}</p>
        </aside>
      </section>
      <MarketingCta />
    </MarketingShell>
  );
}
